import { SVGProps, useId } from 'react';

/**
 * Two overlapping right-pointing triangles for the "next steps" toggle. The back one is masked so
 * there's a gap between the outlines.
 */
export const NextStepsIcon = (props: SVGProps<SVGSVGElement>) => {
  const maskId = useId();
  // Left triangle sits in front; right triangle sits behind, offset ~4px to the right.
  const frontPath =
    'M0.5 1.00098C0.500176 0.623251 0.903318 0.382148 1.23633 0.560547L11.1182 5.89062C11.47 6.07912 11.47 6.58299 11.1182 6.77148L1.23633 12.1016C0.903318 12.28 0.500176 12.0389 0.5 11.6611V1.00098Z';
  const backPath =
    'M4.5 1.00098C4.50018 0.623251 4.90332 0.382148 5.23633 0.560547L15.1182 5.89062C15.47 6.07912 15.47 6.58299 15.1182 6.77148L5.23633 12.1016C4.90332 12.28 4.50018 12.0389 4.5 11.6611V1.00098Z';

  return (
    <svg data-icon width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <defs>
        <mask id={maskId}>
          <rect width="100%" height="100%" fill="white" />
          {/* Front triangle filled + widely stroked in black to cut this area
              (plus a ~1.5px halo) out of anything drawn with mask={url(#id)}. */}
          <path d={frontPath} fill="black" stroke="black" strokeWidth="3" strokeLinejoin="round" />
        </mask>
      </defs>
      {/* Back triangle — clipped by the mask where it overlaps the front. */}
      <path d={backPath} stroke="currentColor" mask={`url(#${maskId})`} />
      {/* Front triangle on top. */}
      <path d={frontPath} stroke="currentColor" />
    </svg>
  );
};
